import PageBuilderFooterPreview from "./PageBuilderFooterPreview";

export default PageBuilderFooterPreview;